export const userInfo = ({ auth }) => auth.userInfo
export const isUserLoggedIn = ({ auth }) => auth.isUserLoggedIn
export const isAuthInProgress = ({ auth }) => auth.isAuthInProgress
export const loginError = ({ auth }) => auth.error || ''
export const authError = ({ auth }) => auth.error
export const needsReauth = ({ auth }) => Boolean(auth.needsReauth)
